module.exports = __webpack_public_path__ + "img/vz-styling-icons-social-twitter.69b7ca08.svg";